/**
 * round a float to a specified number of decimal places.
 * e.g., `toFixed(3.142, 1) => 3.1
 */
export var toFixed = function (n, fixed) {
    return ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);
};
//# sourceMappingURL=toFixed.js.map